module.exports = __webpack_public_path__ + "img/chevron_big_left_white.svg";